import { META_UTM_CAMPAIGN_KEY } from '@ifixit/analytics/utmTracker/meta';
import type { AttributeInput } from '@ifixit/shopify-storefront-client';
import { safeLocalStorage } from '@ifixit/utils';
import Cookies from 'js-cookie';
import type { QueryCart } from '../models/cart';

const FACEBOOK_ATTRIBUTE_KEY = 'facebook_click';
const MOBILE_APP_ATTRIBUTE_KEY = 'mobile_app';

interface SyncAttributesResult {
   attributes: AttributeInput[];
   needsSync: boolean;
}

export function getSyncedAttributes({
   cart,
   isOnMobileApp,
}: {
   cart: QueryCart | null;
   isOnMobileApp: boolean;
}): SyncAttributesResult {
   const localAttributes = new Map([
      [FACEBOOK_ATTRIBUTE_KEY, facebookClickCookieValue()],
      [META_UTM_CAMPAIGN_KEY, metaUtmCampaignValue()],
      [MOBILE_APP_ATTRIBUTE_KEY, isOnMobileApp ? 'true' : 'false'],
   ]);
   const cartAttributes = new Map(cart?.attributes?.map(({ key, value }) => [key, value]));
   const allKeys = new Set([...cartAttributes.keys(), ...localAttributes.keys()]);

   let needsSync = false;
   const syncedAttributes: AttributeInput[] = [];

   for (const key of allKeys) {
      const currentValue = cartAttributes.get(key);

      if (localAttributes.has(key)) {
         const localValue = localAttributes.get(key);
         needsSync ||= localValue != currentValue;
         if (localValue != null) {
            syncedAttributes.push({ key, value: localValue });
         }
      } else if (currentValue) {
         syncedAttributes.push({ key, value: currentValue });
      }
   }

   return { attributes: syncedAttributes, needsSync };
}

/**
 * https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/fbp-and-fbc
 */
function facebookClickCookieValue() {
   return Cookies.get('_fbc') || null;
}

function metaUtmCampaignValue() {
   return safeLocalStorage.getItem(META_UTM_CAMPAIGN_KEY) || null;
}
